import React, { FC, useMemo } from "react";
import classNames from "classnames";
import Footer from "features/DocItemModal/Footer";
import { useAtom } from "jotai";
import { DocItemModal5 } from "features/DocItemModal/DocItemModalComponents/DocItemModal5";
import { DocumentsData } from "constant-data/documentsData";

import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { ModalHeader } from "components/Modal/AppModal";

import useDocuments from "../../hooks/useDocuments";
import {
  openedDocItemAtom,
  selectedDocumentTypeAtom,
} from "../../atoms/documentsAtom";

import styles from "./styles.module.scss";

interface DocItemModalProps {}

export const DocItemModal: FC<DocItemModalProps> = ({}): JSX.Element => {
  const { closeDocItemModal } = useDocuments();
  const [openedDocItem] = useAtom(openedDocItemAtom);
  const [selectedDocumentType] = useAtom(selectedDocumentTypeAtom);
  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3 px-8" as any, styles.container)}
      header={
        <ModalHeader
          title={
            openedDocItem ? `Товар № "${openedDocItem.index}"` : "Новый товар"
          }
          onClose={closeDocItemModal}
        />
      }
      footer={<Footer />}
    >
      {selectedDocumentType?.id
        ? DocumentsData[selectedDocumentType.id].modalModalComponent
        : null}
    </BaseLayout>
  );
};

{
  /*<Accordion
        withIcon={false}
        handleCollapse={() =>
          setAdditionallyCollapse((prevState) => !prevState)
        }
        collapsed={!additionallyCollapse}
        iconClassNames="mr-3.5"
        parent={
          <AccordionParent
            name="Дополнительно"
            collapsed={!additionallyCollapse}
            iconClassNames="mr-3.5"
          />
        }
      >
        <DocItemModal5 elements={additionallyArr} />
      </Accordion>*/
}

/*
*  const additionallyArr: ComponentTypeProps[] = [
    {
      name: "№ документа",
      type: "input",
    },
    {
      name: "На основании чека",
      type: "input",
    },
    {
      name: "Ответственный",
      type: "input",
    },
    {
      name: "Создан в",
      type: "select",
    },
    {
      name: "Долг компании:",
      optionData: "356 ₽",
      type: "textPointer",
    },
    {
      name: "Оплат по документу:",
      optionData: "482 ₽",
      type: "textPointer",
    },
    {
      name: "Клиент должен:",
      optionData: "346 ₽",
      type: "textPointer",
    },
  ];*/
